import { useContext } from 'react'

import { ScreenContext, TScreenProps } from './ScreenProvider'

export const useScreen = (): TScreenProps => useContext(ScreenContext)
